import classNames from 'classnames';
import React, { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
    className?: string;
    spacer?: boolean;
    verticalAlign?: 'top' | 'center' | 'bottom' | 'spaceAround';
    alignment?: 'flex-start' | 'flex-end' | 'center';
}>;

export const ProRow = ({
    children,
    className,
    spacer = false,
    verticalAlign = 'top',
    alignment = 'flex-start',
}: Props) => (
    <div
        className={classNames(
            'ProRow',
            spacer && 'ProRow__space',
            className,
            `ProCol--${verticalAlign}`,
            `ProCol--align-${alignment}`
        )}
    >
        {children}
    </div>
);
